import "./App.css";
import Header from "./Common/Header/Header";
import ContainerComponent from "./Common/ContainerComponent/ContainerComponent";
//import CardComponent from "./Common/CardComponent/CardComponent";

import Home from "./Components/Home/Home";
import { useEffect, useRef, useState } from "react";
import useOnScreen from "./Common/CustomHooks/useOnScreen";
import Skills from "./NewComponents/Skills/Skills";
import Footer from "./Common/Footer/Footer";
import About from "./Components/About/About";
import StepsComponent from "./Common/StepsComponent/StepsComponent";
import ContactMe from "./Components/ContactMe/ContactMe";
import Certifications from "./Components/Certifications/Certifications";
import CustomCurousel from "./Common/CustomCurousel/CustomCurousel";
import NewHeader from "./NewCommon/NewHeader";
import AboutSection from "./NewComponents/AboutSection/AboutSection";
import ExeperienceSection from "./NewComponents/ExperienceSection/ExeperienceSection";
import RecentWorks from "./NewComponents/RecentWorks/RecentWorks";
import NewFooter from "./NewCommon/NewFooter/NewFooter";

function App() {
  const [theme, setTheme] = useState("light");
  const [activeTab, setActiveTab] = useState("Home");

  const headerRef = useRef(null);
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const qualificationRef = useRef(null);
  const skillRef = useRef(null);
  const serviceRef = useRef(null);
  const projectRef = useRef(null);
  const contactMeRef = useRef(null);
  const certificationRef = useRef(null);

  const headerOnScreen = useOnScreen(
    { root: null, rootMargin: "0px", threshold: 1 },
    headerRef
  );
  const homeOnScreen = useOnScreen(
    { root: null, rootMargin: "0px", threshold: 1 },
    homeRef
  );

  const aboutOnScreen = useOnScreen(
    { root: null, rootMargin: "0px", threshold: 1 },
    aboutRef
  );

  const skillOnScreen = useOnScreen(
    { root: null, rootMargin: "0px", threshold: 1 },
    skillRef
  );
  const qualificationOnScreen = useOnScreen(
    { root: null, rootMargin: "0px", threshold: 1 },
    qualificationRef
  );

  const serviceOnScreen = useOnScreen(
    { root: null, rootMargin: "0px", threshold: 1 },
    serviceRef
  );
  const certificationOnScreen = useOnScreen(
    { root: null, rootMargin: "0px", threshold: 1 },
    certificationRef
  );

  const projectOnScreen = useOnScreen(
    { root: null, rootMargin: "0px", threshold: 1 },
    projectRef
  );

  const contactMeOnScreen = useOnScreen(
    { root: null, rootMargin: "0px", threshold: 1 },
    contactMeRef
  );

  useEffect(() => {
    if (homeOnScreen) {
      setActiveTab("Home");
    } else if (aboutOnScreen) {
      setActiveTab("About");
    } else if (qualificationOnScreen) {
      setActiveTab("Qualification");
    } else if (skillOnScreen) {
      setActiveTab("Skills");
    } else if (contactMeOnScreen) {
      setActiveTab("Contact me");
    } else if (projectOnScreen) {
      setActiveTab("Projects");
    } else if (certificationOnScreen) {
      setActiveTab("Certification");
    }
  }, [
    homeOnScreen,
    aboutOnScreen,
    skillOnScreen,
    certificationOnScreen,
    projectOnScreen,
    contactMeOnScreen,
    qualificationOnScreen,
  ]);

  const handleLinkClick = (name) => {
    switch (name) {
      case "Home":
        homeRef.current.scrollIntoView(true);
        break;
      case "About":
        aboutRef.current.scrollIntoView(true);
        break;
      case "Skills":
        skillRef.current.scrollIntoView(true);
        break;
      case "Qualification":
        qualificationRef.current.scrollIntoView(true);
        break;
      case "Services":
        serviceRef.current.scrollIntoView(true);
        break;
      case "Projects":
        projectRef.current.scrollIntoView(true);
        break;
      case "Certification":
        certificationRef.current.scrollIntoView(true);
        break;
      case "Contact me":
        contactMeRef.current.scrollIntoView(true);
        break;

      default:
        homeRef.current.scrollIntoView(true);
        break;
    }

    if (name === "Projects") {
      projectRef.current.scrollIntoView(true);
    }
  };

  // return (
  //   <div className="w-100">
  //     <div
  //       ref={headerRef}
  //       className="w-100"
  //       style={{ position: "fixed", zIndex: 4, top: 0 }}
  //     >
  //       <Header
  //         themeChange={(theme) => setTheme(theme)}
  //         handleLinkClick={(name) => handleLinkClick(name)}
  //         activeTab={activeTab}
  //       />
  //     </div>

  //     <div ref={homeRef}>
  //       <ContainerComponent>
  //         <Home
  //           theme={theme}
  //           goToContactMeComp={() => handleLinkClick("Contact me")}
  //         />
  //       </ContainerComponent>
  //     </div>

  //     <div ref={aboutRef}>
  //       <ContainerComponent containerTitle="About" subTitle="About me">
  //         <About theme={theme} />{" "}
  //       </ContainerComponent>
  //     </div>

  //     <div ref={qualificationRef}>
  //       <ContainerComponent
  //         containerTitle="Qualification"
  //         subTitle="My Qualification"
  //       >
  //         <StepsComponent />
  //       </ContainerComponent>
  //     </div>
  //     <div ref={skillRef}>
  //       <ContainerComponent
  //         containerTitle="Skills"
  //         subTitle="My technical travel"
  //       >
  //         <Skills theme={theme} />
  //       </ContainerComponent>
  //     </div>
  //     {/* <div ref={serviceRef}>
  //       <ContainerComponent containerTitle="Services" subTitle="What I Offer.">
  //         <CardComponent
  //           title="Fronted Developer"
  //           icon={AllImages.WindowGridIcon}
  //         />
  //         <CardComponent
  //           title="React.JS Developer"
  //           icon={AllImages.ArrowCodeIcon}
  //         />
  //         <CardComponent title="Node.JS Developer" icon={AllImages.PenIcon} />
  //       </ContainerComponent>
  //     </div> */}

  //     <div ref={projectRef}>
  //       <ContainerComponent
  //         containerTitle="Projects"
  //         subTitle="My Projects"
  //       >
  //         <CustomCurousel />
  //       </ContainerComponent>
  //     </div>

  //     <div ref={certificationRef}>
  //       <ContainerComponent
  //         containerTitle="Certification"
  //         subTitle="My Certifications"
  //       >
  //         <Certifications />
  //       </ContainerComponent>
  //     </div>

  //     <div ref={contactMeRef}>
  //       <ContainerComponent
  //         containerTitle="Contact Me"
  //         subTitle="My Contact"
  //       >
  //         <ContactMe />
  //       </ContainerComponent>
  //     </div>

  //     <Footer />
  //   </div>
  // );

  return (
    <div>
      {/* header */}
      <div
        style={{
          position: "fixed",
          zIndex: 999,
          width: "100%",
          background: "white",
          top: 0,
        }}
      >
        <NewHeader />
      </div>
      {/* About section */}

      <div id="about" style={{ marginTop: "124px", marginBottom: "40px" }}>
        <AboutSection />
      </div>
      <div id="skills" className="skills-component">
        <Skills />
      </div>

      <div id="experience" className="experience-section-component">
        <ExeperienceSection />
      </div>
      <div id="projects" className="recent-works-component">
        <RecentWorks />
      </div>
      <div id="contact" className="new-footer-component">
        <NewFooter />
      </div>
    </div>
  );
}

//#6e57e0 -- color.
export default App;
